/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One draw's actual time, paired with its draw number. See ParsedTicketGame.drawTimes.
 * @export
 * @interface ParsedDrawTime
 */
export interface ParsedDrawTime {
    /**
     * 
     * @type {Date}
     * @memberof ParsedDrawTime
     */
    drawTime: Date;
    /**
     * 
     * @type {number}
     * @memberof ParsedDrawTime
     */
    drawNumber: number;
}

/**
 * Check if a given object implements the ParsedDrawTime interface.
 */
export function instanceOfParsedDrawTime(value: object): value is ParsedDrawTime {
    if (!('drawTime' in value) || value['drawTime'] === undefined) return false;
    if (!('drawNumber' in value) || value['drawNumber'] === undefined) return false;
    return true;
}

export function ParsedDrawTimeFromJSON(json: any): ParsedDrawTime {
    return ParsedDrawTimeFromJSONTyped(json, false);
}

export function ParsedDrawTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedDrawTime {
    if (json == null) {
        return json;
    }
    return {
        
        'drawTime': (new Date(json['drawTime'])),
        'drawNumber': json['drawNumber'],
    };
}

export function ParsedDrawTimeToJSON(value?: ParsedDrawTime | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'drawTime': ((value['drawTime']).toISOString()),
        'drawNumber': value['drawNumber'],
    };
}

